import { Button, styled, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Variant } from '../../../models/Product';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const AddToIconButton = styled(Button)(({ theme }) => ({
    minWidth: 0,
    minHeight: 0,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    background: `${theme.palette.primary[400]}`,
    border: `1px solid ${theme.palette.primary[400]}`,
    color: 'white',
    height: '40px',
    ':hover': {
        background: theme.custom.primaryBtnColor,
        border: '1px solid black',
        color: 'black',
    },
}));

export const CollectionProductAddToQuotation: React.FC<{
    variant: Variant;
    quantity: number;
}> = (props) => {
    const { variant, quantity } = props;
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });

    return (
        <Tooltip title={t('ADD_TO')} placement="left-start">
            <AddToIconButton>
                <NoteAddIcon />
            </AddToIconButton>
        </Tooltip>
    );
};
